import script from "./PreLander.vue?vue&type=script&setup=true&lang=js"
export * from "./PreLander.vue?vue&type=script&setup=true&lang=js"

import "./PreLander.vue?vue&type=style&index=0&id=4da3cf53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da3cf53"]])

export default __exports__